import { resetPriceGeneration } from "./priceGenerationTracker";
import { invalidateRoomKindOrder } from "./roomKindOverridesApi";

/**
 * Forget what the tab holds about the property it was showing.
 *
 * Room kinds — and the order they are drawn in — belong to one property, and
 * so does the price recalculation the Prices page waits on. The pages remount
 * rather than reload, so both are dropped whenever the property under them
 * changes: after a switch made in this tab (`useDashboardInit`), and when the
 * tab turns out to show a property no longer open (`App.tsx`), since a page
 * read during that moment may have filled them with the other property's.
 */
export function forgetPropertyCaches(): void {
    invalidateRoomKindOrder();
    resetPriceGeneration();
}
